// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item-divider {
  padding: 0;
  border: 0;
}
ion-item-divider#search-divider #filter-btn {
  --padding-end: 24px;
}
ion-item-divider #subtitle-2 {
  display: flex;
  align-items: center;
  width: 100%;
  padding-top: 16px;
  padding-bottom: 16px;
}
ion-item-divider #subtitle-2 #product-stock-title,
ion-item-divider #subtitle-2 #product-stock-add {
  width: 50%;
  color: var(--ion-text-color);
}
ion-item-divider #subtitle-2 #product-stock-title {
  margin-left: 24px;
  font-size: 17px;
  font-weight: 700;
}
ion-item-divider #subtitle-2 #product-stock-add {
  font-size: 14px;
  font-weight: 500;
  text-align: right;
}
ion-item-divider #subtitle-2 #product-stock-add ion-button {
  --padding-end: 24px;
  text-transform: capitalize;
}
ion-item-divider #subtitle-2 #product-stock-add ion-button ion-icon {
  margin-right: 3px;
  width: 32px !important;
  height: 32px !important;
}

.container-close {
  margin-right: 0px !important;
}

.store-item {
  font-size: 14px !important;
}

.item-category {
  font-weight: 700 !important;
}

.item-subcategory {
  font-weight: 600 !important;
}

.item-num-prods {
  font-weight: 500 !important;
}

ion-thumbnail {
  justify-content: center;
  display: flex;
}
ion-thumbnail img {
  border-radius: 6px;
  width: auto;
  height: auto;
}

.thumbnail-no-image {
  background: #acc5e3;
  border-radius: 6px;
}
.thumbnail-no-image ion-label {
  font-size: 18px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/store/components/coupons/categories-list/categories-list.page.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,SAAA;AACF;AAMI;EACE,mBAAA;AAJN;AAQE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;AANJ;AAQI;;EAEE,UAAA;EACA,4BAAA;AANN;AAQI;EACE,iBAAA;EACA,eAAA;EACA,gBAAA;AANN;AASI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAPN;AAQM;EACE,mBAAA;EACA,0BAAA;AANR;AAOQ;EACE,iBAAA;EACA,sBAAA;EACA,uBAAA;AALV;;AAYA;EACE,4BAAA;AATF;;AAYA;EACE,0BAAA;AATF;;AAYA;EACE,2BAAA;AATF;;AAWA;EACE,2BAAA;AARF;;AAUA;EACE,2BAAA;AAPF;;AAUA;EAEE,uBAAA;EACA,aAAA;AARF;AAUE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AARJ;;AAYA;EACE,mBAAA;EACA,kBAAA;AATF;AAWE;EACE,eAAA;EACA,iBAAA;AATJ","sourcesContent":["ion-item-divider {\n  padding: 0;\n  border: 0;\n\n  &#search-divider {\n    // ion-searchbar {\n    //   margin-right: 0;\n    // }\n\n    #filter-btn {\n      --padding-end: 24px;\n    }\n  }\n\n  #subtitle-2 {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    padding-top: 16px;\n    padding-bottom: 16px;\n\n    #product-stock-title,\n    #product-stock-add {\n      width: 50%;\n      color: var(--ion-text-color);\n    }\n    #product-stock-title {\n      margin-left: 24px;\n      font-size: 17px;\n      font-weight: 700;\n    }\n\n    #product-stock-add {\n      font-size: 14px;\n      font-weight: 500;\n      text-align: right;\n      ion-button {\n        --padding-end: 24px;\n        text-transform: capitalize;\n        ion-icon {\n          margin-right: 3px;\n          width: 32px !important;\n          height: 32px !important;\n        }\n      }\n    }\n  }\n}\n\n.container-close{\n  margin-right: 0px !important;\n}\n\n.store-item {\n  font-size: 14px !important;\n  // color: var(--ion-color-primary, black);\n}\n.item-category {\n  font-weight: 700 !important;\n}\n.item-subcategory {\n  font-weight: 600 !important;\n}\n.item-num-prods {\n  font-weight: 500 !important;\n}\n\nion-thumbnail {\n  //align-items: center;\n  justify-content: center;\n  display: flex;\n\n  img {\n    border-radius: 6px;\n    width: auto;\n    height: auto;\n  }\n}\n\n.thumbnail-no-image{\n  background: #acc5e3;\n  border-radius: 6px;\n\n  ion-label{\n    font-size: 18px;\n    font-weight: bold;\n  }\n}\n\n//PWA\n@media (min-width: 960px) {\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
